import React, { useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { DateField, TimeField } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";

interface DefaultInputSmallProps {
  label: string;
  placeholder: string;
  initialValue: string;
  onChanged: (newValue: string) => void;
}

export const DefaultInputSmall = ({
  label,
  initialValue,
  onChanged,
  placeholder,
}: DefaultInputSmallProps) => {
  const [value, setValue] = useState(initialValue);

  const handleValueChange = ({ target: { value } }: any) => {
    setValue(value);
    onChanged(value);
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        flex: 1,
        border: "1px solid #D6D6DB",
        borderTop: "none",

        "&:first-of-type": {
          borderTop: "1px solid #D6D6DB",
          borderTopLeftRadius: "6px",
          borderTopRightRadius: "6px",

          "&>.leftBlock": {
            borderTopLeftRadius: "6px",
          },
        },
        "&:last-child, &:last-child>.leftBlock": {
          borderBottomLeftRadius: "6px",
          borderBottomRightRadius: "6px",
        },
      }}
    >
      <Box
        className="leftBlock"
        sx={{
          display: "flex",
          alignItems: "center",
          height: "46px",
          minWidth: 170,
          paddingLeft: "16px",
          backgroundColor: "#F3F3F3",
          color: "#1F1F1F",
          borderRight: "none",
        }}
      >
        <Typography
          sx={{
            fontWeight: "500",
            fontSize: "14px",
            cursor: "default",
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          padding: "0px 16px",
          flex: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            flex: 1,
          }}
        >
          <TextField
            value={value}
            onChange={handleValueChange}
            placeholder={placeholder}
            sx={{
              width: "100%",
              borderRadius: "6px",
              border: "none",

              "& .MuiInputBase-input": {
                height: "46px",
                padding: "0px",
                fontSize: "14px",
                color: "#080808",
                borderRadius: "6px",
                border: "none",

                "&::placeholder": {
                  color: "#676767",
                  opacity: 1,
                },
              },

              "&:hover": {
                boxShadow: "none",
              },
              [`& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline,
             & .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline,
             & .MuiOutlinedInput-notchedOutline`]: {
                border: "none",
                borderRadius: "6px",
                boxShadow: "none",
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};
